import { useCallback, useEffect, useState } from 'react'
import { getCalendarStatus, DsGmeetRepCalendar } from '../api/dsGmeetApi'

export function useCalendarStatus(userId: string) {
    const [data, setData] = useState<DsGmeetRepCalendar[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const refetch = useCallback(async () => {
        if (!userId) return
        setLoading(true)
        setError('')
        try {
            setData(await getCalendarStatus(userId))
        } catch (err) {
            setError(err instanceof Error ? err.message : String(err))
        } finally {
            setLoading(false)
        }
    }, [userId])

    useEffect(() => {
        void refetch()
    }, [refetch])

    return { data, loading, error, refetch }
}
